import { Show } from 'solid-js'
import { useIntl } from '@cookbook/solid-intl'

import BannerMoleculeComponent from '../banner-molecule-component/banner-molecule-component.jsx'
import ButtonAtomComponent from '../../atoms/button-atom/button-atom-component.jsx'
import LinkAtomComponent from '../../atoms/link-atom/link-atom-component.jsx'
import { useCookieBannerController } from './cookie-banner-controller.js'
import { messages } from './cookie-banner.messages.en.js'
import './cookie-banner.scss'

/**
 * Non-blocking cookie consent banner. Mirrors the visual pattern of the
 * referral-sender banner in `public-template-component` — fixed to the
 * bottom-right of the viewport in a compact card so the page content
 * remains scrollable and interactive. Hidden once consent has been
 * recorded (Accept or Decline).
 *
 * Wired to PostHog only in this MVP. GA4 / Reddit / Meta pixel are not
 * gated. See the consent-banner MVP plan for the full deferred follow-ups.
 */
export default function CookieBanner () {
    const intl = useIntl()
    const controller = useCookieBannerController()

    return (
        <Show when={controller.showBanner()}>
            <BannerMoleculeComponent
                class="cookie-banner-component"
                hideIcon
                hideCloseButton
                body={
                    <>
                        <div class="cookie-banner-component__content">
                            <div class="cookie-banner-component__content__title">
                                {controller.titleText}
                            </div>
                            <div class="cookie-banner-component__content__body">
                                {intl.formatMessage(messages.body, {
                                    privacyLink: chunks => (
                                        <LinkAtomComponent
                                            class="cookie-banner-component__content__privacy-link"
                                            href="/privacy-policy"
                                        >
                                            {chunks}
                                        </LinkAtomComponent>
                                    ),
                                })}
                            </div>
                        </div>
                        <div class="cookie-banner-component__footer">
                            <ButtonAtomComponent
                                class="cookie-banner-component__footer__button-right"
                                onClick={controller.decline}
                            >
                                {controller.labels.decline}
                            </ButtonAtomComponent>
                            <ButtonAtomComponent
                                class="cookie-banner-component__footer__button-left"
                                onClick={controller.accept}
                            >
                                {controller.labels.accept}
                            </ButtonAtomComponent>
                        </div>
                    </>
                }
            />
        </Show>
    )
}
